import { render, staticRenderFns } from "./Wp_my_update_bind_phone.vue?vue&type=template&id=a33b5244&scoped=true&"
import script from "./Wp_my_update_bind_phone.vue?vue&type=script&lang=js&"
export * from "./Wp_my_update_bind_phone.vue?vue&type=script&lang=js&"
import style0 from "./Wp_my_update_bind_phone.vue?vue&type=style&index=0&id=a33b5244&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a33b5244",
  null
  
)

export default component.exports